window.igInitAll = function () {
  document.querySelectorAll('.instagram-follow__slider').forEach(function (el) {
    if (el.dataset.igInit) return;
    el.dataset.igInit = 'true';

    var sectionId = el.id.replace('instagram-follow-swiper-', '');
    var settings = (window.igSectionSettings && window.igSectionSettings[sectionId]) || {};

    new Swiper(el, {
      slidesPerView: settings.slidesPerViewMobile || 1.2,
      spaceBetween: settings.spaceBetween || 8,
      loop: settings.loop || false,
      autoplay: settings.autoplay ? {
        delay: settings.autoplayDelay || 4000,
        disableOnInteraction: false
      } : false,
      breakpoints: {
        750: {
          slidesPerView: settings.slidesPerViewDesktop || 3.2
        }
      }
    });
  });
};

function igTryInit() {
  if (typeof Swiper === 'undefined') {
    setTimeout(igTryInit, 50);
    return;
  }
  window.igInitAll();
}

if (document.readyState !== 'loading') {
  igTryInit();
} else {
  document.addEventListener('DOMContentLoaded', igTryInit);
}